import React from 'react'
import classnames from 'classnames'
import { MenuItemProps } from 'antd/lib/menu/MenuItem'

type AppMenuItemProps = MenuItemProps & {
    title: string
    className?: string
}

export const MenuItemLabel = ({ title, className }: AppMenuItemProps) => {
    return (
        <div className={classnames('app-menu-item', className)}>
            <span>{title}</span>
        </div>
    )
}
